import { render, staticRenderFns } from "./ExportWizardColumns.vue?vue&type=template&id=718a2110"
import script from "./ExportWizardColumns.vue?vue&type=script&lang=js"
export * from "./ExportWizardColumns.vue?vue&type=script&lang=js"
import style0 from "./ExportWizardColumns.vue?vue&type=style&index=0&id=718a2110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports